import { Route } from '@angular/router';

export const notFoundRoute: Route = {
  path: '**',
  pathMatch: 'full',
  redirectTo: '/home',
};
